import { FormButton, FormButtonProps } from "@rhf-kit/mui";
import { PropsWithChildren } from "react";

export const Button = (props: PropsWithChildren<FormButtonProps>) => {
    const { children, sx, ...rest } = props;

    return (
        <FormButton {...rest} sx={{ textTransform: "none", ...sx }}>
            {children}
        </FormButton>
    );
};
